"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

exports.__esModule = true;
exports.OpenAQCodec = exports.OpenAQCodecOptional = exports.sourceTypeCodec = exports.unitCodec = exports.pollutantCodec = exports.latLngCodec = exports.attributionsCodec = void 0;

var t = __importStar(require("io-ts"));
/**
 * @ignore
 */


exports.attributionsCodec = t.array(t.intersection([t.type({
  name: t.string
}), t.partial({
  url: t.string
})]));
/**
 * @ignore
 */

exports.latLngCodec = t.union([t.type({
  latitude: t.number,
  longitude: t.number
}), t.undefined]);
/**
 * @ignore
 */

exports.pollutantCodec = t.union([// FIXME
// Instead of rewriting these, can we use the types and array defined in
// import { AllPollutants, Pollutant } from '@shootismoke/convert';
t.literal('bc'), t.literal('ch4'), t.literal('co'), t.literal('c6h6'), t.literal('ox'), t.literal('nh3'), t.literal('nmhc'), t.literal('no'), t.literal('nox'), t.literal('no2'), t.literal('o3'), t.literal('pm10'), t.literal('pm25'), t.literal('so2'), t.literal('trs')]);
/**
 * @ignore
 */

exports.unitCodec = t.union([t.literal('ppb'), t.literal('ppm'), t.literal('µg/m³')]);
/**
 * @ignore
 */

exports.sourceTypeCodec = t.union([t.literal('government'), t.literal('research'), t.literal('other')]); // Required fields for OpenAQ data format

var OpenAQCodecRequired = t.type({
  city: t.string,
  coordinates: exports.latLngCodec,
  country: t.string,
  date: t.type({
    local: t.string,
    utc: t.string
  }),
  location: t.string,
  parameter: exports.pollutantCodec,
  sourceName: t.string,
  value: t.number,
  unit: exports.unitCodec
}); // Optional fields for OpenAQ data format

exports.OpenAQCodecOptional = t.partial({
  attribution: exports.attributionsCodec,
  averagingPeriod: t.type({
    unit: t.string,
    value: t.number
  }),
  mobile: t.boolean,
  sourceType: exports.sourceTypeCodec
});
/**
 * An io-ts codec to validate the OpenAQ data format.
 *
 * @see https://github.com/openaq/openaq-data-format
 */

exports.OpenAQCodec = t.intersection([OpenAQCodecRequired, exports.OpenAQCodecOptional]);